import { useEffect } from 'react'

export function AgentOnboardingComplete() {
  useEffect(() => {
    window.location.href = 'https://propps.com/how-it-works'
  }, [])

  return null
}
